<template>
    <div id="fs5-code-of-ethics">
        <div class="header ba-card" v-html="view[0]['t']['code_of_ethic']"></div>
        <fs5-view-rank-details :view="view[1]"></fs5-view-rank-details>
        <br>
        <fs5-get-paid-collapse
        id="get-paid-collapse"
            :view="view[2]">
            <div :slot="'content'" slot-scope="props">
                <fs5-get-paid-tutorial :view="props.content"></fs5-get-paid-tutorial>
            </div>
        </fs5-get-paid-collapse>
        <br>
        <fs5-get-paid-collapse
        id="get-paid-collapse"
            :view="view[3]">
            <div class="box-affiliate" :slot="'content'" slot-scope="props">
                <p class="item-box" v-html="view[0]['t']['fs5_code_of_ethics_coexistence']"></p>
                <p class="item-box-title" v-html="view[0]['t']['fs5_code_of_ethics_title']"></p>
                <p class="item-box" v-html="view[0]['t']['fs5_code_of_ethics']"></p>
            </div>
        </fs5-get-paid-collapse>
        <!-- <br>
        <div class="content-box ba-card">
            <div class="content-item-2">
                <div class="content-item-img">
                    <img src="/internacional/public/office5/img/franchise_dashboard/svg/star.svg" alt="">
                    <p v-html="view[0]['t']['fs5_code_of_ethics_promoting']"></p>
                </div>
                <div>
                    <p class="item-box-title" v-html="view[0]['t']['fs5_code_of_ethics_title_mandatory']"></p>
                    <p class="item-box" v-html="view[0]['t']['fs5_code_of_ethics_message_top']"></p>
                </div>
                <fs5-button
                    :label="view[0]['t']['fs5_code_of_ethics_template']"
                    :btn-type="'primary'"
                    :text-transform-type="'uppercase'"
                    @clicked="go(1)"
                ></fs5-button>
            </div>
        </div> -->
    </div>
</template>

<script>
    export default {
        name: 'fs5-code-of-ethics',
        props: ['view'],
        data() {
            return {
            }
        },
        methods: {
            go(data)
            {
                if(data == 1)
                {
                    window.open(this.view[0]['templatelink'], '_blank');
                }
            },
        },
    }
</script>

<style scoped lang="scss">
    @import '../../../../scss/extras/_variables'; // see fonts and colors with prefix $fs5
    #fs5-get-paid-index {
        font-family: $fs5-font2;
        font-family: Lato;
    }
    .header{
        color: $fs5-color11;
        line-height: 1.2;
        font-weight: 900;
        font-size: 1.5em;
        margin-bottom: 0.7em;
        text-transform: uppercase;
    }
    #get-paid-collapse{
        font-size: 0.5em !important;
        .box-affiliate{
            background-color: $fs5-color2;
            padding: 1em;
            border: 1px solid $fs5-color1;
            border-radius: 0.8em;
            .item-box,
            .item-box-title{
                color: $fs5-color19;
                font-size: 0.8em;
                line-height: 1.4em;
                font-weight: 200;
            }
            .item-box-title{
                font-size: 1em;
                font-weight: bold;
            }
        }
    }
    .content-box{
        .content-item-2{
            display: grid;
            grid-template-columns: 1fr 1fr 2fr 2fr;
            column-gap: 6%;
            background-color: $of-color19;
            padding: 2em;
            border-radius: 0.8em;
            align-items: center;
        }
        .content-item-2{
            grid-template-columns: 1fr 2fr 1fr;
        }
        .content-item-img{
            display: flex;
            flex-direction: row;
            align-items: center;
            gap: 3%;
            p{
                color: $fs5-color5;
                font-weight: bold;
                margin: 0 !important;
            }
        }
        .item-box,
        .item-box-title{
            color: $fs5-color19;
            font-size: 0.7em;
            line-height: 1.4em;
            font-weight: 200;
        }
        .center{
            text-align: center;
        }
        .item-box-title{
            font-size: 0.7em;
            font-weight: bold;
        }
    }
    @media only screen and (max-width: 1150px) {
        .content-box{
            .content-item-2{
                display: flex;
                flex-direction: column;
            }
            .content-item-img{
                margin-bottom: 1em;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// resources/office/js/components/franchise_v5/code_of_ethics/index.vue